<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2024-03-20 10:22:35
 * @FilePath: \community-backendf:\community-frontend\src\components\card\momentCard.vue
 * @Description: 长文卡片
-->
<template>
  <!-- dragstart禁止是为了防止视频受routink的默认事件导致进度条和音量调节触发拖拽 -->
  <router-link 
    :to="threadRoute" 
    class="moment-card"
    :class="`threadBox${index}`"
    @dragstart.stop.prevent
    @click="onClickItem"
    v-longPress.stop.prevent="isWap ? onShowOptions : ''"
  >
    <div class="moment-card-author-info">
      <!-- 用户头像 -->
      <Avatar
        :avatarInfo="avatarInfo"
        :size="isWap ? 32 : 40"
        :iconSize="isWap ? 11 : 12"
        :callBack="callBack"
      >
        <!-- 昵称 -->
        <div class="avatar-info">
          <div class="nickname">
            <span>{{avatarInfo.nickname}}</span>
            <ThemeTag v-if="tagName" :text="tagName === 'Product Ambassador' ? $t('productAmbassador') : tagName"/>
          </div>
          <span class="info">
            {{$timeFormat(cardData.mtime || cardData.ctime)}}
            {{`${cardData.model ? '· ' : ''}${cardData.model ? cardData.model : ""}`}}
          </span>
        </div>
      </Avatar>
      <div class="right-action">
        <svg-icon v-if="props.showStick" name="icon-stick"/>
        <div v-if="props.cardInfo?.stamp*1" class="best-pick">
          <!-- <svg-icon :name="`icon-best-pick-${brandName}`"></svg-icon> -->
          <img :src="bestMedal[brandName]"/>
          <span v-if="isWeb">{{ $t('highlights') }}</span>
        </div>
        <el-popover
          placement="bottom-end"
          trigger="hover"
          popper-class="action-popover"
        >
          <template #reference>
            <div class="pop-trigger">
              <svg-icon class="icon-more" v-if="props.showIconMore" name="icon-more"/>
            </div>
          </template>
          <dl class="more-action">
            <dt v-if="actionType === 'thread'" @click="onSticky">{{ cardData.stick ? $t('unStickyProfile') : $t('stickyProfile')}}</dt>
            <dt v-else @click="cancelMark">{{$t('unMark')}}</dt>
          </dl>
        </el-popover>
      </div>
    </div>
    
    <!-- 内容 -->
    <div class="moment-card-main">
      <p :style="{
        '-webkit-line-clamp': contentLineClamp
      }">
        <TooltipTag v-if="cardData.verified"/>
        <span class="content" v-html="cardData.content"></span>
      </p>
      <!-- 话题 -->
      <div class="moment-card-topic" v-if="cardData.topicInfo && JSON.parse(cardData.topicInfo).length && route.name!=='topic' && isWap">
        <router-link @click.stop="entryTopic" :to="topicRoute">#{{getTopicId(cardData.topicInfo, 'name')}}</router-link>
      </div>
      <PlyrVideoComponent 
        v-if="videoInfo?.videoType"
        :videoInfo="videoInfo"
        :ratio="isWap ? cardData.attachmentList?.[0]?.width /cardData.attachmentList?.[0]?.height < 0.75 ? '3:4' : '16:9' : '16:9'"
      />
      <template v-else>
        <div class="img-box">
          <ObImg
            v-for="({ url, oliveInfo }, index) in props.cardInfo?.attachmentList.slice(0, previewCount)"
            :src="url"
            :showLiveImg="!!oliveInfo"
            :lazy="true"
            formatWidth="780"
            @click.stop.prevent="onPreview(index,oliveInfo)"
          />
          <div class="more" v-if="props.cardInfo?.attachmentList.length > previewCount">+{{props.cardInfo?.attachmentList.length - previewCount}}</div>
        </div>
      </template>
    </div>
    <!-- 帖子状态 -->
    <div v-if="showStatus && cardData.status > 1" class="card-status">
      <svg-icon :name="`icon-${getStatus(cardData.status).text}`" :color="getStatus(cardData.status).color"/>

      <span :style="{
        color: getStatus(cardData.status).color
      }">{{ $t(getStatus(cardData.status).text) }}</span>
    </div>
    <!-- 归属圈子/帖子点赞数/评论数 -->
    <div class="moment-card-secondary-info">
      <CircleTag :index="index" :showTag="showTag" :circleInfo="circleData" :showTab="showTab"/>
      <div class="social-count">
        <div class="social-count-like">
          <Like 
            :uid="avatarInfo?.id"
            :id="cardData?.id" 
            :count="threadCount.praiseCount" 
            :status="cardInfo.praised"
            @update:count="updateCount"
            @update:status="updateStatus"
          />
          <span>{{$numFormat(threadCount.praiseCount)}}</span>
        </div>
        <div class="social-count-msg">
          <svg-icon name="icon-msg"></svg-icon>
          <span>{{$numFormat(threadCount.commentCount)}}</span>
        </div>
      </div>
    </div>
  </router-link>
  <BorderLine v-if="border"/>
  <WapImgPreview 
    v-if="isWap"
    v-model:visible="showPreview"
    :previewList="showList"
    :previewIndex="previewIndex"
  />
  <WebImgPreview 
    v-else
    v-model:visible="showPreview"
    :previewList="showList"
    :previewIndex="previewIndex"
  />
</template>

<script setup>
import { reactive, ref, watch, getCurrentInstance, onMounted, computed } from 'vue'
import { useSystemStore } from '@/stores/system'
import { storeToRefs } from 'pinia'
import filter from '@/utils/filter'

import { useRoute, useRouter } from 'vue-router'
import Xss from '@/utils/xssFilter'

import oppoBest from '@/assets/photo/oppoBest.png'
import oneplusBest from '@/assets/photo/oneplusBest.png'

const route = useRoute()
const router = useRouter()

const { proxy } = getCurrentInstance()

const systemStore = useSystemStore()
const { isApp, isWap, isWeb, isOneplus, versionCode, brandName } = storeToRefs(systemStore)


const emit = defineEmits(['cancelMark', 'cardClick', 'onSticky', 'showAction'])

const props = defineProps({
  cardInfo: {
    type: Object,
    default: () => {
      return {}
    }
  },
  showStick: {
    type: Boolean,
    default: false
  },
  showIconMore: {
    type: Boolean,
    default: false
  },
  showStatus: {
    type: Boolean,
    default: false
  },
  index: {
    type: Number,
    default: 0
  },
  actionType: {
    type: String,
    default: 'marked'
  },
  border: {
    type: Boolean,
    default: true
  },
  showTag: {
    type: Boolean,
    default: true
  },
  showTab: {
    type: Boolean,
    default: false
  },
  titleLineClamp: {
    type: [Number, String],
    default: 1
  },
  contentLineClamp: {
    type: [Number, String],
    default: 2
  },
  callBack: {
    type: Function,
  }
})

const bestMedal = ref({
  oppo: oppoBest,
  oneplus: oneplusBest
})

const PlyrVideoComponent = ref(null)

const cardData = computed(() => {
  const { avatar, iconLink: icon, uid: id, nickname } = props.cardInfo.publishUserInfo
  let circleData = props.cardInfo.circleInfo || props.cardInfo.circleBasicInfo || {}
  circleData.uid = id
  props.cardInfo.subject = Xss(props.cardInfo.subject, {
    "highLight": ["style", "class"],
    "span": ["style", "class"],
  })
  props.cardInfo.content = Xss(props.cardInfo.content, {
    "highLight": ["style", "class"],
    "span": ["style", "class"],
  })
  return {...circleData, ...props.cardInfo}
})

const avatarInfo = ref({
  id: '',
  icon: '',
  avatar: ''
})


const circleData = computed(() => {
  const { circleInfo, circleBasicInfo, publishUserInfo } = props.cardInfo
  const { uid } = publishUserInfo || {}
  const detail = circleInfo || circleBasicInfo || {}
  return {
    ...detail,
    uid
  }
})

const videoInfo = computed(() => {
  let info = {
    videoType: '',
    source: {},
    poster: ''
  }
  const { attachmentList, extList } = props.cardInfo
  if (attachmentList && attachmentList.length) {
    const { id: attachId, type, snapshot, transcodeInfo, url } = attachmentList[0]
    if (attachmentList[0].type === 2) {
      info.videoType = 'video'
      let sources = []
      if (transcodeInfo && transcodeInfo.length) {
        sources = transcodeInfo.map(t => {
          return {
            src: t.url,
            size: Number(t.transType)
          }
        })
      } else {
        sources.push({
          src: url,
        })
      }
      info.source = {
        type: 'video',
        poster: snapshot ? filter.formatImg(snapshot, type === 1 ? 360 : 1520) : '',
        sources
      }
    }
  }
  if (extList && extList.length) {
    info.videoType = 'youtube'
    info.source = {
      type: 'video',
      sources: extList.map(y => {
        return {
          src: y.url,
          provider: 'youtube'
        }
      })
    }
  }
  if (info.videoType) {
    PlyrVideoComponent.value = markRaw(defineAsyncComponent(() => import('@/components/plyrVideo.vue')))
  }
  return info
})

const previewList = computed(() => {
  const { attachmentList, extList } = props.cardInfo
  let list = []
  if (attachmentList && attachmentList.length) {
    attachmentList.forEach(item => {
      const { id: attachId, type, snapshot, transcodeInfo, url,oliveInfo } = item
      if (type !== 2 && !extList?.length && !oliveInfo) {
        list.push(item.url)
      }
      if(oliveInfo){
        list.push({
          type:5,
          url:item.url,
          ...oliveInfo
      })}
    });
  }
  return list
})

const tagName = computed(() => {
  const { publishUserInfo } = props.cardInfo
  let name = ''
  switch (publishUserInfo.identityType) {
    case 1:
      name = route.name === 'circle' ? proxy.$t('circleOwner') : ''
      break
    case 2:
      name = route.name === 'circle' ? proxy.$t('circleAssistant') : ''
      break
    default:
      name = publishUserInfo.tag
  }
  if (route.name === 'home') {
    name = ''
  }
  return name
})


const threadCount = computed(() => {
  const { threadStat } = props.cardInfo || {}
  let data = {
    praiseCount: 0,
    commentCount: 0
  }
  if (threadStat && Object.keys(threadStat).length) {
    data = { ...threadStat }
  }
  return data
})


const threadRoute = computed(() => {
  return (isApp.value && route.name === 'abroadList') || isOneplus.value ? {} : {
    name: 'thread',
    params: {
      id: cardData.value?.id
    }
  }
})

const topicRoute = computed(() => {
  return (isApp.value && route.name === 'abroadList') || isOneplus.value ? {} : {
    name: 'topic',
    params: {
      id: getTopicId(props.cardInfo.topicInfo, 'id')
    }
  }
})

const previewCount = computed(() => {
  return isWeb.value ? 4 : 3
})

const showPreview = ref(false)
const showList = ref([])
const previewIndex = ref(0)
const onPreview = (index) => {
  showList.value = previewList.value.slice(0, previewCount.value)
  previewIndex.value = index
  showPreview.value = true
}

const bsetIcon = async () => {
  return await import(`@/assets/photo/${brandName.value}Best.png`)
}

const updateCount = (count) => {
  props.cardInfo.threadStat.praiseCount = count
}

const updateStatus = (status) => {
  props.cardInfo.praised = status
}


const cancelMark = () => {
  emit('cancelMark', cardData.value.id)
}

const onSticky = () => {
  emit('onSticky', cardData.value)
}

const onShowOptions = (el) => {
  let { clientX: left, clientY: top } = el.tapObj
  emit('showAction', {
    cardInfo: cardData.value,
    left,
    top
  })
}


const entryTopic = () => {
  sendGaData('click_topic_entry', {
    "entry_position": route.name,
  })
  if (isOneplus.value && versionCode.value < 41600) {
    router.push({
      name: 'topic',
      params: {
        id: getTopicId(props.cardInfo.topicInfo, 'id')
      }
    })
    return
  }
  if ((isApp.value && route.name === 'abroadList') || isOneplus.value) {
    proxy.$openNewWebview(`${location.origin}/topic/${getTopicId(props.cardInfo.topicInfo, 'id')}`, {
      name: 'topic',
      params: {
        id: getTopicId(props.cardInfo.topicInfo, 'id')
      }
    })
  }
}

const onClickItem = () => {
  sendGaData('click_thread_entry', {
    "entry_position": route.name,
  })
  if (props.callBack) {
    props.callBack()
  }
  
  if (isOneplus.value && versionCode.value < 41600) {
    router.push({
      name: 'thread',
      params: {
        id: cardData.value.id
      }
    })
    return
  }
  if ((isApp.value && route.name === 'abroadList') || isOneplus.value) {
    proxy.$openNewWebview(`${location.origin}/thread/${cardData.value.id}`, {
      name: 'thread',
      params: {
        id: cardData.value.id
      }
    })
  }
  emit('cardClick', cardData.value.id)
}

// 解析话题json字符串
const getTopicId = (item, key) => {
  // 防止json id过长精度丢失
  let newItem = item.replace(/\"id\":(\d+)/g,'"id":"$1"')
  // 帖子卡片只展示第一个话题
  newItem = JSON.parse(newItem)[0]
  return newItem[key]
}

const getStatus = (status) => {
  let statusInfo = {
    color: '',
    text: ''
  }
  switch (status) {
    case 2:
      statusInfo.color = 'var(--text-secondary)'
      statusInfo.text = 'reviewing'
      break
    case 3:
      statusInfo.color = '#0070cc'
      statusInfo.text = 'notApproved'
      break
    default:
  }
  return statusInfo
}

watch(() => props.cardInfo, (val) => {
  let circleData = val.circleInfo || val.circleBasicInfo || {}
  const { avatar, iconLink: icon, uid: id, nickname, dressInfo } = val.publishUserInfo
  circleData.uid = id
  // cardData.value = {circleData,...val}
  avatarInfo.value = { id, icon, avatar, nickname, ...dressInfo }
}, {
  immediate: true,
  deep: true
})

const sendGaData = (name, data) => {
  const params = {
    "screen_name": route.name,
    "thread_category": props.cardInfo?.type,
    "thread_id": props.cardInfo.id,
    "circle_id": props.cardInfo?.circleInfo?.id,
    "circle_name": props.cardInfo?.circleInfo?.name,
    "topic": props.cardInfo?.topicInfo && JSON.parse(props.cardInfo?.topicInfo) ? JSON.parse(props.cardInfo?.topicInfo)[0]?.name : '',
    "module": route.name,
    "position": props.index + 1,
    "author_id": props.cardInfo?.publishUserInfo?.uid
  }
  proxy.$ga(name, {...params,...data})
}

onMounted(() => {
  try {
    // 帖子卡片曝光埋点
    let io = new IntersectionObserver((a,b) => {
      if (a[0].intersectionRatio > 0) {
        // 帖子曝光 埋点
        try{
          sendGaData('thread_impression', {
            "module": route.name,
          })
        }catch(e){}
        io.unobserve(document.querySelector(`.threadBox${props.index}`))
      }
    });
    io.observe(document.querySelector(`.threadBox${props.index}`))
  } catch (error) {
    
  }
})
</script>

<style lang="postcss" scoped>
.moment-card {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 24px 0;
  &-author-info {
    display: flex;
    flex-flow: row nowrap;
    align-items: top;
    justify-content: space-between;
    width: 100%;
    .avatar-info {
      display: flex;
      flex-flow: column wrap;
      align-items: flex-start;
      justify-content: flex-start;
      margin-left: 12px;
      overflow: hidden;
      span {
        width: 100%;
        word-break: break-word;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .nickname {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 4px;
      }
      span:first-child {
        font-size: 16px;
        line-height: 100%;
        margin-right: 4px;
      }
      .info {
        font-size: 14px;
        line-height: 130%;
        color: var(--text-hint);
      }
    }
    .svg-icon {
      width: 24px;
      height: 24px;
      margin-left: 8px;
    }
  }
  &-main {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    overflow: hidden;
    margin: 8px 0 12px;
    p {
      display: -webkit-box;
      width: 100%;
      margin-bottom: 4px;
      line-height: 21.6px;
      word-break: break-word;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-box-orient: vertical;
      font-size: 16px;
      color: var(--text-primary);
      -webkit-line-clamp: 4;
    }
    .img-box {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      position: relative;
      margin-top: 8px;
      .ob-image {
        flex-shrink: 0;
        width: 195px;
        height: 146px;
        margin-right: 4px;
      }
      .more {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        right: 8px;
        bottom: 8px;
        background: rgba(0,0,0,.4);
        color: hsla(0,0%,100%,.85);
        font-size: 12px;
        border-radius: 12px;
        height: 24px;
        padding: 0 10px;
      }
    }
  }
  &-topic {
    a {
      color: var(--text-dark-blue);
    }
  }
  &-secondary-info {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    width: 100%;
    .social-count {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      div {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;
        /* min-width: 24px;
        min-height: 24px; */
        span {
          font-size: 14px;
          color: var(--text-secondary);
        }
      }
      div:first-child {
        margin-right: 16px;
      }
      &-like {
        .icon-unlike {
          color: var(--text-secondary);
        }
      }
      &-msg {
        .svg-icon {
          color: var(--text-secondary);
        }
      }
      .svg-icon {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }
    }
  }
}
.icon-more {
  color: var(--background-hint);
}
.pop-trigger {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.more-action {
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  justify-content: center;
  padding: 8px 0;
  overflow: hidden;
  dt {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    font-size: 14px;
    padding: 11px 24px;
    cursor: pointer;
    &:empty {
      display: none;
    }
  }
  dt:hover {
    background-color: var(--background-light);
  }
}
.card-status {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: row nowrap;
  margin-bottom: 16px;
  span {
    margin-left: 8px;
  }
}
.right-action {
  display: flex;
  align-items: center;
  .best-pick {
    align-self: center;
    display: flex;
    align-items: center;
    span {
      color: var(--text-secondary);
      margin-left: 4px;
      font-size: 14px;
    }
    img {
      width: 24px;
      height: 24px;
      margin-left: 8px;
    }
  }
}
.action-list {
  padding: 8px 24px;
  dt {
    height: 42px;
    display: flex;
    align-items: center;
  }
}
@media (max-width: 1023px) {
  .moment-card {
    padding: 16px 20px;
    .avatar {
      :deep(.avatar-image .el-image:first-child) {
        :deep(.el-image__error) {
          font-size: 12px;
        }
      }
      .nickname {
        margin-bottom: 2px;
        span{
          font-size: 14px !important;
          color: var(--text-primary);
        }
      }
      span {
        font-size: 12px !important;
      }

    }
    .content {
      font-size: 12px;
      line-height: 130%;
      -webkit-line-clamp: 2;
      word-break: break-word;
    }
    .social-count {
      .svg-icon {
        width: 24px;
        height: 24px;
      }
      span {
        font-size: 12px !important;
      }
    }
    .img-box {
      width: 100%;
      .ob-image {
        width: calc((100vw - 40px - 4px) / 3);
        height: calc((100vw - 40px - 4px) / 3);
        margin-right: 0;
        &:nth-child(3n+2) {
          margin: 0 2px;
        }
      }
      .more {
        /* display: block; */
      }
    }
    :deep(.plyr-video .plyr--video) {
      margin-top: 8px;
      width: calc(100vw - 40px);
      .plyr__control--overlaid {
        --plyr-control-spacing: 14px;
        --plyr-control-icon-size: 24px;
        svg {
          width: 18px !important;
          height: 18px !important;
        }
      }
    }
  }
  .card-status {
    margin-bottom: 12px;
    .svg-icon {
      width: 16px !important;
      height: 16px !important;
    }
    span {
      margin-left: 2px;
      font-size: 12px !important;
    }
  }
}
</style>
<style lang="postcss">
.el-popper {
  --el-popover-padding: 0;
  --el-popover-border-radius: 8px;
  .el-popper__arrow {
    display: none;
  }
}
.action-popover {
  width: auto !important;
}
</style>